module.exports = __webpack_public_path__ + "img/StartFromScratch-icon.19efee1b.svg";